import {getDataApi} from "@/features/buyOneClick/api/buyOneClickApi";
import {useBuyOneClickStore} from "@/Stores/Site/BuyOneClickStore";

export function useOpenBuyOneClick() {
    const loading = useBuyOneClickStore(state => state.loading);
    const setLoading = useBuyOneClickStore(state => state.setLoading);
    const openModal = useBuyOneClickStore(state => state.openModal);
    const closeModal = useBuyOneClickStore(state => state.closeModal);
    const setData = useBuyOneClickStore(state => state.setData);

    const openBuyOneClick = async (productId, size) => {
        try {
            if (loading) return;

            setLoading(true);
            openModal();

            const response = await getDataApi({productId, size});
            const {success} = response.data;
            const {status = false, data = []} = success;

            if (!status) return handleError();

            const {productData = [], productDataCurrent = {}, onlineDiscount = 0, onlineDiscountSbp = 0} = data;
            setData({productId, productData, productDataCurrent, onlineDiscount, onlineDiscountSbp});
        } catch (e) {
            handleError();
        } finally {
            setLoading(false);
        }
    }

    const handleError = () => {
        closeModal();
    };

    return {openBuyOneClick, loading};
}
